import React from 'react';
import { Link } from 'react-router-dom';
import {
  formatNewsDate,
  getNewsHref,
  isExternalHref,
  type NewsItem,
} from '../data/news';
import styles from './NewsList.module.css';

interface NewsListProps {
  items: readonly NewsItem[];
}

/**
 * お知らせの罫線リスト。トップの「お知らせ」節と /news 一覧で共用する。
 * 記事（slug あり）はサイト内リンク、外部 URL は新しいタブ、どちらも無ければリンクにしない。
 */
const NewsList: React.FC<NewsListProps> = ({ items }) => {
  return (
    <ul className={styles.list}>
      {items.map((item) => {
        const href = getNewsHref(item);
        return (
          <li key={`${item.date}-${item.title}`} className={styles.row}>
            <p className={styles.date}>
              <time dateTime={item.date}>{formatNewsDate(item.date)}</time>
            </p>
            <h3 className={styles.title}>
              {!href ? (
                item.title
              ) : isExternalHref(href) ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  {item.title}
                  <span className={styles.srOnly}>
                    （外部サイト・新しいタブで開きます）
                  </span>
                  <span className={styles.arrow} aria-hidden="true">
                    {' '}
                    →
                  </span>
                </a>
              ) : (
                <Link to={href} className={styles.link}>
                  {item.title}
                  <span className={styles.arrow} aria-hidden="true">
                    {' '}
                    →
                  </span>
                </Link>
              )}
            </h3>
          </li>
        );
      })}
    </ul>
  );
};

export default NewsList;
